// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Zzvjl","dot":"styles_dot__Aogkk","dotChecked":"styles_dotChecked__+OjI6"};